import { AddCircleOutline } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
// import '../../../../css/Contract.css';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; //https://fkhadra.github.io/react-toastify/introduction/
import DeleteComponent from "../../DeleteComponent";

const ContractSection = (props) => {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const vendorId = props.vendorId;

  const handChange = (e) => {
    const image = e.target.files[0];
    if (image.size <= 10000000) {
      if (image) {
        let storage = props.firebase.getStorage();
        const uploadTask = storage
          .ref(`vendors/${vendorId}/contract/${image.name}`)
          .put(image);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            setProgress(progress);
          },
          (error) => {
            toast.error(error);
          },
          () => {
            storage
              .ref(`vendors/${vendorId}/contract/`)
              .child(image.name)
              .getDownloadURL()
              .then(async (url) => {
                setProgress(0);
                const contract = {
                  fileRef: url,
                  fileName: image.name,
                };
                props.firebase.createContract(vendorId, contract);
                setLoading(true);
                toast.success("Contract Uploaded");

                if (loading) {
                  try {
                    const contracts = await props.firebase.getContracts(
                      vendorId
                    );

                    setContracts(contracts);
                    setLoading(false);
                  } catch (err) {
                    toast.error(err);
                  }
                }
              });
          }
        );
      } else {
        toast.error("Error please choose a file to upload");
      }
    } else {
      toast.error("Error please choose a file size less than 10MB");
    }
  };

  const deleteContract = async (fileName, docId) => {
    let storage = props.firebase.getStorage();
    const fileRef = storage.ref(`vendors/${vendorId}/contract/${fileName}`);
    fileRef
      .delete()
      .then(async () => {
        await props.firebase.deleteContract(vendorId, docId);

        setLoading(true);
      })
      .catch((err) => {
        // setError("Error Unable to delete")
        props.firebase.deleteContract(vendorId, docId);
        toast.error(err);
        setLoading(true);
      });
    const contracts = await props.firebase.getContracts(vendorId);
    setContracts(contracts);
  };

  useEffect(() => {
    const getData = async () => {
      if (loading) {
        try {
          const contracts = await props.firebase.getContracts(vendorId);

          setContracts(contracts);
          setLoading(false);
        } catch (err) {
          // console.log(err)
        }
      }
    };
    getData();
  }, [loading, props.firebase, vendorId]);

  const handleClick = () => {
    const uploadbtn = document.querySelector("#cont_btn");
    uploadbtn.click();
  };
  let grid = contracts.map((contract, index) => {
    return (
      <tr key={index}>
        <td>{contract.fileName}</td>
        <td>{contract.uploadedDate.toDateString()}</td>
        <td>
          <a className="download" href={contract.fileRef} target="blank">
            Download
          </a>
        </td>
        <td>
          <DeleteComponent
            delete={() => deleteContract(contract.fileName, contract.Id)}
            fileName={contract.fileName}
          />
        </td>
      </tr>
    );
  });
  return (
    <div className="contract_cont">
      <ToastContainer />
      <div className="ctr contract">
        <div className="ctr_el_header">
          <h3>Contracts</h3>
          <div className="add_btn">
            <input
              type="file"
              name="myfile"
              id="cont_btn"
              onChange={handChange}
            />
            <AddCircleOutline className="icon" onClick={(e) => handleClick()} />
          </div>
          {progress > 0 ? <progress value={progress} max="100" /> : <></>}
        </div>

        <div className="content">
          <p>
            These are the record of all contracts signed between you, Spryte,
            and our clients
          </p>
        </div>
      </div>

      <div className="contract_bottom">
        {grid.length !== 0 ? (
          <table className="stable">
            <thead className="stable_header">
              <tr>
                <th>File</th>
                <th>Uploaded Date</th>
                <th>Download</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>{grid}</tbody>
          </table>
        ) : (
          <div className="resource-header">
            <p
              style={{
                color: "red",
                fontWeight: "500",
                opacity: ".65",
                fontStyle: "italic",
                paddingTop: "25px",
              }}
            >
              You do not have any contracts uploaded
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContractSection;
